<template>
  <div class="card boxWithBorder">
    <p class="modal-card-title gant-text mb-5">Tell Us About Your Trip</p>
    <div class="">
      <div class="mb-5">
        <div class="label">Who is traveling?</div>
        <b-field>
          <b-radio
            v-model="$globals.travellers.bookFor"
            name="user"
            native-value="user"
          >
            Me ({{ $globals.profile.firstName }}
            {{ $globals.profile.lastName }})
          </b-radio>
          <b-radio
            v-model="$globals.travellers.bookFor"
            name="others"
            native-value="others"
          >
            Someone else
          </b-radio>
        </b-field>
      </div>
    </div>
    <b-modal
      v-model="isComponentModalActive"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-label="Example Modal"
      aria-modal
    >
      <template #default="props">
        <TravellerAddGuest
          v-bind="profiler"
          @close="props.close"
          @update="addGuest"
        />
      </template>
    </b-modal>
    <div v-if="$globals.travellers.bookFor === 'others'">
      <b-field
        label="Book for one of my travelers"
        label-position="on-border"
        :key="forceKey"
      >
        <TagAutocomplete
          :onlyOne="true"
          placeholder="e.g. John Smith"
          icon="magnify"
          :chainData="
            dependentTravellers.map((x) => [
              x,
              x.firstName +
                ' ' +
                (x.middleName ? x.middleName[0] + '. ' : '') +
                x.lastName,
            ])
          "
          :selected="designatedTravellers"
          @list="
            (option) => {
              designatedTravellers = option;
            }
          "
        >
        </TagAutocomplete>
      </b-field>
      <div>
        <a
          v-if="designatedTravellers.length === 0"
          @click="isComponentModalActive = true"
        >
          <u>Book for a guest traveler</u>
        </a>
      </div>
    </div>

    <div class="mt-5 mb-5" v-if="showPersonal">
      <div class="label">Is this a business or personal trip?</div>
      <b-field>
        <b-radio
          v-model="$globals.travellers.tripType"
          name="business"
          native-value="business"
        >
          Business
        </b-radio>
        <b-radio
          v-model="$globals.travellers.tripType"
          name="personal"
          native-value="personal"
        >
          Personal
        </b-radio>
      </b-field>
    </div>

    <b-button
      :disabled="disabled"
      label="Save"
      @click="save"
      type="is-primary"
      expanded
    />
  </div>
</template>

<script>
import TagAutocomplete from "../Tags/TagAutocomplete.vue";
import TravellerAddGuest from "./TravellerAddGuest.vue";

export default {
  name: "TravellerModal",
  props: {
    profiler: Object,
    mounted: Boolean,
    closable: Boolean,
  },
  components: {
    TagAutocomplete,
    TravellerAddGuest,
  },
  data: function() {
    return {
      isOpen: 0,
      dependentTravellers: [],
      loggedInUserProfile: this.$store.state.travellersAndTrips.profile,
      loading: false,
      designatedTravellers: [],
      business: true,
      isComponentModalActive: false,
    };
  },
  computed: {
    disabled() {
      return !(
        this.designatedTravellers.length > 0 ||
        this.$globals.travellers.bookFor === "user"
      );
    },
    result() {
      return this.$store.state.bookTravel.result;
    },
    showPersonal() {
      if (this.disabled) {
        return false;
      } else {
        // MT - We are currently using the profile of the loggedIn user to determine if personal travel is allowed.
        //in the future we may want to update this to use the *selected* traveler's profile. To do this we will need to 
        //move this question to a second step that takes places after we have selected and saved the traveller profile
        let profile = this.loggedInUserProfile;

        if (profile.account?.allowPersonalTravel) {
          return true;
        } else {
          return false;
        }
      }
    },
    tripType() {
      return this.$globals.travellers.tripType;
    },
  },
  methods: {
    save() {
      if (
        this.$globals.travellers.set &&
        (!this.$helpers.isEmptyObject(this.result.car) ||
          !this.$helpers.isEmptyObject(this.result.flight) ||
          !this.$helpers.isEmptyObject(this.result.hotel))
      ) {
        this.confirm();
      } else {
        this.confirmSave();
      }
    },
    async addGuest(data = null) {
      // console.log('called addGuest', data);
      await this.getDependentTravellers(data);
    },
    cardModal() {
      let details = {
        parent: this,
        component: TravellerAddGuest,
        props: {
          profiler: this.$globals.profile,
        },
        hasModalCard: true,
        trapFocus: false,
        width: 700,
        events: {
          update: (value) => {
            this.addGuest(value);
          },
        },
      };
      this.$buefy.modal.open(details);
    },
    confirm() {
      this.$buefy.dialog.confirm({
        message: `You have travel in your itinerary that is linked to another traveller's policy. Changing travellers now will delete this trip. Do you wish to continue?`,
        onConfirm: () => {
          this.$buefy.toast.open("Travellers changed");
          this.$store.commit("clearState/CLEAR_DETAILS");
          this.confirmSave();
        },
      });
    },
    confirmSave() {
      //console.log('confirmSave()');
      this.setTravellers();
      this.$store.dispatch(`bookTravel/hDelResult`);
      this.$store.dispatch(`bookTravel/cDelResult`);
      this.$store.dispatch(`bookTravel/delResult`);
      this.$emit("close");
      this.$nav.pushRouteTo({ name: "BookingLetsGetGoing" });
      //console.log('close after confirmSave')
    },

    getDependentTravellers(data = null) {
      // console.log('called getDependentTravellers', data);
      if (data) {
        this.loading = true;

        /*
        this.$globals.travellers.others = [
          [
            data,
            data.firstName +
              " " +
              (data.middleName ? data.middleName[0] + ". " : "") +
              data.lastName,
          ],
        ];
        
        */

        //this.designatedTravellers = data;

      }

      

      let body = { contactId: this.$globals.profile.id };
      this.$app
        .huddleLabsServerCall("profile/my-travelers", body)
        .then((result) => {
          // console.log('getDependentTravellers', result);
          if (!result.error) {
            this.dependentTravellers = result.data;
            this.forceKey_forceKeyChange();
            // console.log('this.dependentTravellers', this.dependentTravellers);
          }
        });

      this.loading = false;
      return this.dependentTravellers;
    },
    setTravellers() {
      this.$globals.travellers.set = true;
      // console.log('setTravellers', this.$globals.travellers);

      this.$store.commit(
        "travellersAndTrips/EDIT_TRAVELLERS",
        this.$globals.travellers
      );

      if (this.$globals.travellers.bookFor === "others") {
        if (
          !this.$store.state.travellersAndTrips.otherProfiles[
            this.designatedTravellers[0][0].id
          ]
        ) {
          var body = {
            contactId: this.designatedTravellers[0][0].id,
            includeRelated: [
              "travelerPrograms",
              "paymentMethods",
              "unusedTickets",
              "travelPolicy",
              "preferredVendors",
            ],
          };
          this.$app
            .huddleLabsServerCall("profile/travel-profile", body)
            .then((result) => {
              // console.log('result of setTravellers', result);
              if (!result.error) {

                console.log(result.data);

                this.$store.commit("travellersAndTrips/ADD_OTHER_PROFILE", [
                  this.designatedTravellers[0][0].id,
                  result.data,
                ]);


              //set current traveller profile to selected traveller
              this.$store.commit("travellersAndTrips/SET_TRAVELLER_PROFILE", result.data);
              //this.$store.dispatch("travellersAndTrips/setTravellerProfile", result.data);

                window.location.reload();
              }
            });
        }


      }
    },
  },
  mounted() {
    this.getDependentTravellers();
    /*
    this.travellers = Object.assign(
      {},
      this.$store.getters["travellersAndTrips/getTravellers"]
    );
    */
  },
  updated() {
    // this.forceKey_forceKeyChange();
  },
};
</script>

<style scoped></style>
